import Skeleton from "react-loading-skeleton";
import cn from "classnames";
import sharedStyles from "../shared.module.scss";
import styles from "./TextField.module.scss";

export function TextField({ title, value, loading }) {
  return (
    <div className={styles.label}>
      <div className={cn(styles.title, sharedStyles.formText)}>{title}</div>
      <div className={sharedStyles.formText}>
        {loading ? (
          <Skeleton className={styles.value} />
        ) : (
          <div className={styles.value}>{value}</div>
        )}
      </div>
    </div>
  );
}
